import { ServerDeploymentType, ServerFeature } from '@affine/graphql';

import type { ServerConfig, ServerMetadata } from './types';

export function isBackendDisabled() {
  return !!(globalThis as { __AFFINE_DISABLE_BACKEND__?: boolean })
    .__AFFINE_DISABLE_BACKEND__;
}

function localOrigin() {
  try {
    return globalThis.location?.origin ?? '';
  } catch {
    return '';
  }
}

/**
 * This fork does not ship AFFiNE Cloud hosts.
 * DI still needs one server record so local IndexedDB workspaces can boot.
 */
export const BUILD_IN_SERVERS: (ServerMetadata & { config: ServerConfig })[] = [
  {
    id: 'affine-cloud',
    baseUrl: localOrigin(),
    config: {
      serverName: 'Local',
      features: [ServerFeature.LocalWorkspace],
      oauthProviders: [],
      type: ServerDeploymentType.Affine,
      credentialsRequirement: {
        password: {
          minLength: 8,
          maxLength: 32,
        },
      },
    },
  },
];

export type TelemetryChannel =
  | 'stable'
  | 'beta'
  | 'internal'
  | 'canary'
  | 'local';

export function getOfficialTelemetryEndpoint(
  _channel = BUILD_CONFIG.appBuildType
): string {
  return '';
}
